// Keep OLAYZ product videos in sync with the active carousel slide.
(() => {
  let scheduled = false;
  const videos = () => document.querySelectorAll('media-gallery .olayz-inline-video video');

  function markReady(video) {
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && video.videoWidth > 0) {
      video.closest('.olayz-inline-video')?.classList.add('olayz-video-ready');
    }
  }

  function sync() {
    scheduled = false;
    for (const video of videos()) {
      markReady(video);
      const slide = video.closest('slideshow-slide');
      const active = slide && slide.getAttribute('aria-hidden') === 'false' && !slide.hidden && !document.hidden;
      if (!active) {
        if (!video.paused) video.pause();
        continue;
      }
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      if (video.paused) {
        const attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(() => { video.controls = false; }).catch(() => { video.controls = true; });
        }
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  document.addEventListener('slideshow:select', schedule);
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('pageshow', schedule);
  document.addEventListener('loadeddata', (event) => {
    if (event.target instanceof HTMLVideoElement && event.target.closest('.olayz-inline-video')) markReady(event.target);
  }, true);
  document.addEventListener('playing', (event) => {
    if (event.target instanceof HTMLVideoElement && event.target.closest('.olayz-inline-video')) markReady(event.target);
  }, true);
  document.addEventListener('canplay', (event) => {
    if (event.target instanceof HTMLVideoElement && event.target.closest('.olayz-inline-video')) schedule();
  }, true);
  document.addEventListener('pointerup', schedule, true);
  document.addEventListener('touchend', schedule, true);

  const observer = new MutationObserver((records) => {
    if (records.some(record => record.type === 'childList' || record.attributeName === 'aria-hidden')) schedule();
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
